import React from 'react';

interface Props {
  className?: string;
  color?: string;
  width: string | number;
  height?: string | number;
  tooltip?: string | React.ReactNode;
  children: (props: { color: string | number; width: string | number; height: string | number }) => {};
  onClick?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>['onClick'];
  style?: Record<string, any>;
}

const Image = (props: Props) => {
  const {
    color, width, height, tooltip, children, ...spanProps
  } = props;
  return (
    <span data-tip={tooltip} {...spanProps}>
      {// @ts-ignore
      children({ color, width: width == null ? height : width, height: height == null ? width : height })
      }
    </span>
  );
};

export default Image;
